"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTodayFuturesPnlV2 = exports.calculateTotalFuturesPnl = exports.useFuturesPnl = exports.FuturesPnlUtils = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const StatisticsApi_1 = require("../../apis/StatisticsApi");
const trade_utils_lib_1 = require("trade_utils_lib");
function createPollingObserver(trigger, pollingDuration = 5000) {
    return (0, rxjs_1.merge)((0, rxjs_1.timer)(0, 5000, rxjs_1.asapScheduler), trigger);
}
const createPublish = (subject) => {
    return createPollingObserver(subject).pipe((0, operators_1.switchMap)(() => (0, StatisticsApi_1.getBalancesStat)().pipe((0, operators_1.catchError)(() => (0, rxjs_1.of)(null)))), (0, operators_1.publishBehavior)(null), (0, operators_1.refCount)());
};
const refreshSubject = new rxjs_1.Subject();
const futuresStatSubject = createPublish(refreshSubject);
function getObservable() {
    return futuresStatSubject;
}
function refresh() {
    refreshSubject.next(Date.now());
}
/**合约盈亏： 包含今日盈亏，近7日盈亏以及近30日盈亏 */
exports.FuturesPnlUtils = {
    getObservable,
    refresh,
};
/**获取合约账户盈亏数据 */
function useFuturesPnl(isActive = true) {
    const [stat, setStat] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        const sub = exports.FuturesPnlUtils.getObservable().subscribe({
            next: setStat,
            error: () => {
                setStat(null);
            }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [isActive]);
    return { stat };
}
exports.useFuturesPnl = useFuturesPnl;
// // 今日盈亏=当前资产-零点资产-出入金
function calculateTotalFuturesPnl(params) {
    const { totalAsset, withdraw_deposit, midnight_access } = params;
    return new trade_utils_lib_1.SafeDecimal(totalAsset).sub(new trade_utils_lib_1.SafeDecimal(withdraw_deposit)).sub(new trade_utils_lib_1.SafeDecimal(midnight_access)).toString();
}
exports.calculateTotalFuturesPnl = calculateTotalFuturesPnl;
/**
 * 获取今日盈亏
 */
function useTodayFuturesPnlV2(totalAsset, isActive = true) {
    const { stat: statInfo } = useFuturesPnl(isActive);
    return (0, react_1.useMemo)(() => {
        // 盈亏=当前资产-零点资产-出入金
        return statInfo
            ? calculateTotalFuturesPnl({
                totalAsset,
                withdraw_deposit: statInfo.withdraw_deposit,
                midnight_access: statInfo.midnight_access,
            })
            : "";
    }, [statInfo, totalAsset]);
}
exports.useTodayFuturesPnlV2 = useTodayFuturesPnlV2;
